// extracted by mini-css-extract-plugin
export default {"search-group-header":"search-group-header--2wyE9","title":"title--3uLt4"};